/**
 * Componente para mostrar el estado de una tarea cron
 * Badge de estado y tiempo restante
 */
import React, { useMemo } from 'react'
import { CheckCircleIcon, XCircleIcon } from '@heroicons/react/24/outline'
import type { CronTaskStatusData } from '../../types/cron/cronTasks'

interface CronTaskStatusProps {
  status: CronTaskStatusData | null
  countdown: {
    hours: number
    minutes: number
    seconds: number
    humanReadable: string
    isExpired: boolean
  }
}

const CronTaskStatus: React.FC<CronTaskStatusProps> = React.memo(
  ({ status, countdown }) => {
    const isEnabled = useMemo(() => status?.enabled ?? false, [status?.enabled])

    if (!status) {
      return (
        <div className="flex items-center space-x-2">
          <div className="h-3 w-3 bg-gray-300 rounded-full"></div>
          <span className="text-sm text-gray-500">Cargando...</span>
        </div>
      )
    }

    return (
      <div className="flex flex-col space-y-2">
        {/* Badge de estado */}
        <div className="flex items-center space-x-2">
          {isEnabled ? (
            <>
              <CheckCircleIcon className="h-5 w-5 text-green-500" />
              <span className="text-sm font-medium text-green-700">Activa</span>
            </>
          ) : (
            <>
              <XCircleIcon className="h-5 w-5 text-red-500" />
              <span className="text-sm font-medium text-red-700">Inactiva</span>
            </>
          )}
        </div>

        {/* Tiempo restante */}
        {isEnabled && (
          <div className="flex items-center space-x-2">
            <span className="text-xs text-gray-500">Próxima ejecución:</span>
            <span
              className={`text-sm font-semibold ${
                countdown.isExpired
                  ? 'text-orange-600'
                  : countdown.hours < 1
                  ? 'text-yellow-600'
                  : 'text-blue-600'
              }`}
            >
              {countdown.humanReadable}
            </span>
          </div>
        )}
      </div>
    )
  }
)

CronTaskStatus.displayName = 'CronTaskStatus'

export default CronTaskStatus

